'use client'

import {Card, CardBody, CardFooter, CardHeader} from '@heroui/react'
import Link from 'next/link'
import {useRouter} from 'next/navigation'
import React, {useEffect} from 'react'
import {useSession} from 'next-auth/react'
import Cookies from 'js-cookie'

import AmyButton from '@/components/UI/AmyButton/AmyButton'
import Box from '@/components/UI/Box/Box'
import Icon from '@/components/UI/Icon/Icon'
import {Body4, Body5} from '@/components/UI/Typography'

import {Logger} from '@/src/shared/lib/fetcher/fetcher'
import {ClientError} from '@/src/shared/lib/fetcher/error'

const ErrorPage = ({error}: {error: Error | ClientError}) => {
  const {data: session} = useSession()
  const router = useRouter()

  useEffect(() => {
    const xTraceId = Cookies.get('x-trace-id')

    if (error instanceof ClientError) {
      const errorResp = JSON.parse(error.message)
      Logger(
        {
          message: 'Client Error',
          code: errorResp?.code,
          url: `${process.env.NEXT_PUBLIC_FE_LOCAL}${errorResp?.url}`,
          status: 500,
          userInformation: {
            'x-trace-id': xTraceId,
            'x-advicemy-id': session?.userId,
          },
        },
        false
      )
    } else {
      Logger(
        {
          message: 'Client Error',
          code: error?.message,
          stack: error.stack,
          cause: error.cause,
          userInformation: {
            'x-trace-id': xTraceId,
            'x-advicemy-id': session?.userId,
          },
        },
        false
      )
    }
  }, [error, session?.userId])

  return (
    <Box className="w-full justify-center py-12 px-2">
      <Card className="max-w-[500px] w-full p-4">
        <CardHeader className="flex-col items-center gap-4">
          <Box className="p-6 rounded-full bg-red-50">
            <Icon name="warning" className="fill-primary" size={48} />
          </Box>
          <Body4 className="font-bold text-primary">Bir hata oluştu</Body4>
        </CardHeader>
        <CardBody>
          <Body5 className="text-center">
            Beklenmedik bir hata oluştu, işleminizi şuanda gerçekleştiremiyoruz.
            Hatanın devam etmesi halinde whatsapp hattımızdan iletişime
            geçebilirsiniz.
          </Body5>
        </CardBody>
        <CardFooter className="flex-col gap-2">
          <AmyButton
            fullWidth
            variant="bordered"
            type="button"
            onClick={() => router.back()}>
            Önceki Sayfaya Dön
          </AmyButton>
          <AmyButton fullWidth color="primary" type="button" as={Link} href="/">
            Ana Sayfaya Dön
          </AmyButton>
        </CardFooter>
      </Card>
    </Box>
  )
}

export default ErrorPage
